// Chakra imports
import {
  Portal,
  Box,
  useDisclosure,
  useColorModeValue,
} from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';
import { useState } from 'react';
import { useSidebar } from 'hooks/useSidebar';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import routes from 'routes';
import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { usePageTitle } from 'hooks/usePageTitle';
import { RootState } from 'redux/store';
import FooterPortalCiudadano from 'components/footer/FooterUser';
import ObrasUrbanizacion from 'views/ObrasPublicas/ObrasUrbanizacion';
import ObrasAnuncio from 'views/ObrasPublicas/ObrasAnuncio';
import ObrasConstancia from 'views/ObrasPublicas/ObrasConstancia';
import ObrasConstruccionBase from 'views/ObrasPublicas/ObrasConstruccionBase';
import ObrasDemolicion from 'views/ObrasPublicas/ObrasDemolicion';
import ObrasDivisionTerrenos from 'views/ObrasPublicas/ObrasDivisionTerrenos';
import ObrasFraccionamiento from 'views/ObrasPublicas/ObrasFraccionamiento';
import ObrasMultaObstruccion from 'views/ObrasPublicas/ObrasMultaObstruccion';
import ObrasObstruccionTemporal from 'views/ObrasPublicas/ObrasObstruccionTemporal';
import ObrasPanteon from 'views/ObrasPublicas/ObrasPanteon';
import ObrasRegistroContratista from 'views/ObrasPublicas/ObrasRegistroContratista';
import GestionTramitesOP from 'views/ObrasPublicas/GestionTramites/GestionTramitesOP';
import DashboardObrasPublicas from 'views/ObrasPublicas/Dashboard/DashboardObrasPublicas';

// Mapeo externo de perfiles a rutas permitidas
const rolePermissions: Record<string, string[]> = {
  A1: [
    '/admin/plan-de-trabajo',
    '/admin/agenda',
    '/admin/oficialia',
    '/admin/usuarios',
    '/admin/sistema/turnos',
    '/admin/informe-de-actividades',
    '/admin/atencion-ciudadana',
    '/admin/gestion-juridica-legal',
    '/admin/gestion-contrataciones-licitaciones',
    '/admin/transparencia-rendicion-cuentas',
    '/admin/gestion-documentacion-legal',
    '/admin/gestion-documentos-correspondencia',
    '/admin/actas-minutas',
    '/admin/gestion-recursos-humanos',
    '/admin/control-documentacion-legal-administrativa',
    '/admin/planificacion-seguimiento-proyectos',
    '/admin/atencion-gestion-solicitudes-ciudadanas',
    '/admin/seguridad-control-acceso',
    '/admin/auditoria-interna',
    '/admin/control-finanzas-presupuesto',
    '/admin/gestion-contrataciones-licitaciones',
    '/admin/cumplimiento-normativo',
    '/admin/atencion-quejas-denuncias',
    '/admin/control-procedimientos-administrativos',
    '/admin/gestion-documentacion-registros',
    '/admin/Catalogos/catalogo',
    '/admin/sistema/usuarios',
    '/admin/sistema/s_iniciadas',
    '/admin/sistema/r_acciones',
    '/admin/tesoreria/propietarios',
    '/admin/tesoreria/ciudadanos',
    '/admin/tesoreria/predios',
    '/admin/tesoreria/transaccionescgeneral',
    '/admin/tesoreria/AguaPotable',
    '/admin/tesoreria/CFacturados',

    '/admin/tesoreria/transacciones',
    '/admin/tesoreria/tarifas',
    '/admin/tesoreria/recursos-humanos',
    '/admin/tesoreria/reportes-analisis-financiero',
    '/admin/tesoreria/control-deuda',
    '/admin/tesoreria/gestion-inversiones',
    '/admin/tesoreria/gestion-subsidios-subvenciones',
    '/admin/tesoreria/gestion-activos-fijos',
    '/admin/tesoreria/control-contratos-pagos',
    '/admin/tesoreria/gestion-impuestos-contribuciones',
    '/admin/tesoreria/recaudacion',

    '/admin/comerciales',
    '/admin/vinos-licores',
    '/admin/licencias-estado',

    '/admin/residuos-materiales',
    '/admin/predios',
    '/admin/agua-potable',
    '/admin/multas',
    '/admin/obras-publicas',
    '/admin/obras-menu',

    '/admin/urbanizacion',
    '/admin/fraccionamiento',
    '/admin/division-terrenos',
    '/admin/anuncios',
    '/admin/panteones',
    '/admin/demoliciones',
    '/admin/constancias',
    '/admin/contratistas',
    '/admin/obstruccion-temporal',
    '/admin/multas-obstruccion',
    '/admin/index',
    '/admin/dictamenes',
    '/admin/bitacoras',
    '/admin/gestion-tramites',
    '/admin/gestion-tramites-op',
    '/admin/obras-dashboard',

    '/admin/causas',
    '/admin/juzgado/detenciones',
    '/admin/juzgado/infracciones',
    '/admin/juzgado/audiencias',
    '/admin/juzgado/caja',
    '/admin/obras-oficialia',
    '/admin/tesoreria/online-pays',
    '/admin/policia/multas',
    '/admin/policia/reportes',
    '/admin/juez/multas',
    '/admin/seguridad-publica/infracciones',
    '/admin/seguridad-publica/estadisticas',

    '/admin/cultura/dashboard',
    '/admin/cultura/planeacion',
    '/admin/cultura/programas',
    '/admin/cultura/eventos',
    '/admin/cultura/talleres',
    '/admin/cultura/promotores',
    '/admin/cultura/artistas',

    '/admin/turismo/dashboard',
    '/admin/turismo/planes',
    '/admin/turismo/programas',
    '/admin/turismo/atractivos',
    '/admin/turismo/artesanos',
    '/admin/turismo/pan-fiesta',
    '/admin/turismo/productos',
    '/admin/turismo/eventos',
    '/admin/turismo/rutas',
    '/admin/turismo/apoyos',
    '/admin/turismo/capacitaciones',

    '/admin/desarrollo-social/dashboard',
    '/admin/desarrollo-social/beneficiarios',
    '/admin/desarrollo-social/programas',
    '/admin/desarrollo-social/apoyos',
    '/admin/desarrollo-social/reportes',
    '/admin/desarrollo-social/movimientos',

    // ── MÓDULOS 2026 (A1 superadmin ve todo) ──
    '/admin/servicios/dashboard', '/admin/servicios/recoleccion', '/admin/servicios/faenas',
    '/admin/servicios/herramientas', '/admin/servicios/alumbrado', '/admin/servicios/panteones',
    '/admin/servicios/limpieza-camiones', '/admin/servicios/decoracion', '/admin/servicios/bitacora',
    '/admin/deportes/dashboard', '/admin/deportes/torneos', '/admin/deportes/deportistas',
    '/admin/deportes/convocatorias', '/admin/deportes/inventario', '/admin/deportes/catalogos',
    '/admin/imm/dashboard', '/admin/imm/expedientes', '/admin/imm/atenciones', '/admin/imm/casos',
    '/admin/imm/canalizaciones', '/admin/imm/banavim', '/admin/imm/ordenes', '/admin/imm/decisiones',
    '/admin/imm/solicitudes', '/admin/imm/psicologia', '/admin/imm/talleres', '/admin/imm/agenda',
    '/admin/imm/constancias',
  ],
  OP1: [
        '/admin/obras-oficialia',

      '/admin/obras-menu',

    '/admin/urbanizacion',
    '/admin/fraccionamiento',
    '/admin/division-terrenos',
    '/admin/anuncios',
    '/admin/panteones',
    '/admin/demoliciones',
    '/admin/constancias',
    '/admin/contratistas',
    '/admin/obstruccion-temporal',
    '/admin/multas-obstruccion',
    '/admin/gestion-tramites',
    '/admin/gestion-tramites-op',
    '/admin/obras-dashboard',
],
  PC1: ['/admin/dictamenes', '/admin/bitacoras'],
  JM1: [
    '/admin/juzgado/detenciones',
    '/admin/juzgado/infracciones', // Infracciones / Calificar
    '/admin/juzgado/audiencias',
    '/admin/causas', // Registro de Remisiones
    '/admin/juez/multas', // Multas (Juez)
    '/admin/juzgado/caja', // Caja — Pago Sanciones
  ],
  DE1: [
    '/admin/comerciales',
    '/admin/vinos-licores',
    '/admin/licencias-estado',

    '/admin/residuos-materiales',
  ],
  CA1: ['/admin/tesoreria/AguaPotable', '/admin/tesoreria/propietarios','/admin/sistema/turnos',],
  C1: [
    '/admin/tesoreria/predios',
    '/admin/usuarios',
    '/admin/tesoreria/transaccionescgeneral',
    '/admin/tesoreria/propietarios',
    '/admin/sistema/turnos',
  ],
  CU1: [
    '/admin/cultura/dashboard',
    '/admin/cultura/planeacion',
    '/admin/cultura/programas',
    '/admin/cultura/eventos',
    '/admin/cultura/talleres',
    '/admin/cultura/promotores',
    '/admin/cultura/artistas',
  ],
  TU1: [
    '/admin/turismo/dashboard',
    '/admin/turismo/planes',
    '/admin/turismo/programas',
    '/admin/turismo/atractivos',
    '/admin/turismo/artesanos',
    '/admin/turismo/pan-fiesta',
    '/admin/turismo/productos',
    '/admin/turismo/eventos',
    '/admin/turismo/rutas',
    '/admin/turismo/apoyos',
    '/admin/turismo/capacitaciones',
  ],
  DS1: [
    '/admin/desarrollo-social/dashboard',
    '/admin/desarrollo-social/beneficiarios',
    '/admin/desarrollo-social/programas',
    '/admin/desarrollo-social/apoyos',
    '/admin/desarrollo-social/reportes',
    '/admin/desarrollo-social/movimientos',
  ],
  // U1:['/admin/comerciales','/admin/predios','/admin/agua-potable','/admin/multas','/admin/obras-publicas','/admin/urbanizacion']
  U1: [
    '/admin/comerciales',
    '/admin/predios',
    '/admin/agua-potable',
    '/admin/multas',
    '/admin/obras-publicas',
    '/admin/obras-menu',

    '/admin/urbanizacion',
    '/admin/fraccionamiento',
    '/admin/division-terrenos',
    '/admin/anuncios',
    '/admin/panteones',
    // '/admin/construccion-base',
    '/admin/demoliciones',
    '/admin/constancias',
    '/admin/contratistas',
    '/admin/obstruccion-temporal',
    '/admin/multas-obstruccion',
    '/admin/index',
  ],
  // ── MÓDULOS 2026: roles por dirección ──
  SM1: [
    '/admin/servicios/dashboard', '/admin/servicios/recoleccion', '/admin/servicios/faenas',
    '/admin/servicios/herramientas', '/admin/servicios/alumbrado', '/admin/servicios/panteones',
    '/admin/servicios/limpieza-camiones', '/admin/servicios/decoracion', '/admin/servicios/bitacora',
  ],
  DEP1: [
    '/admin/deportes/dashboard', '/admin/deportes/torneos', '/admin/deportes/deportistas',
    '/admin/deportes/convocatorias', '/admin/deportes/inventario', '/admin/deportes/catalogos',
  ],
  IMM1: [
    '/admin/imm/dashboard', '/admin/imm/expedientes', '/admin/imm/atenciones', '/admin/imm/casos',
    '/admin/imm/canalizaciones', '/admin/imm/banavim', '/admin/imm/ordenes', '/admin/imm/decisiones',
    '/admin/imm/solicitudes', '/admin/imm/psicologia', '/admin/imm/talleres', '/admin/imm/agenda',
    '/admin/imm/constancias',
  ],
  IMM2: [
    '/admin/imm/dashboard', '/admin/imm/expedientes', '/admin/imm/atenciones', '/admin/imm/casos',
    '/admin/imm/canalizaciones', '/admin/imm/banavim', '/admin/imm/ordenes', '/admin/imm/decisiones',
    '/admin/imm/solicitudes', '/admin/imm/psicologia', '/admin/imm/talleres', '/admin/imm/agenda',
    '/admin/imm/constancias',
  ],
};

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const { ...rest } = props;

  // Obtener el perfil del usuario desde Redux
  const user = useSelector((state: RootState) => state.auth.user);
  const userProfile = user?.rol || 'guest'; // Perfil del usuario actual
  console.log(user?.rol);

  // Obtener rutas permitidas según el perfil del usuario
  const getAllowedRoutes = (routes: RoutesType[], profile: string) => {
    const allowedPaths = rolePermissions[profile] || [];
    return routes
      .map((route) => {
        if (route.collapse && route.items) {
          // Filtrar subrutas
          const filteredItems = route.items.filter((item) =>
            allowedPaths.includes(item.layout + item.path),
          );
          if (filteredItems.length > 0) {
            return { ...route, items: filteredItems };
          }
          return null; // Omitir ruta si no tiene subrutas visibles
        }
        // Validar ruta principal
        return allowedPaths.includes(route.layout + route.path) ? route : null;
      })
      .filter(Boolean); // Eliminar rutas nulas
  };

  const allowedRoutes = getAllowedRoutes(routes, userProfile);

  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { mini, setMini, hovered, setHovered } = useSidebar();
  const location = useLocation();

  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };

  const pageTitle = usePageTitle(allowedRoutes);

  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: number) => {
      if (route.layout === '/admin') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };

  const { onOpen } = useDisclosure();
  const bg = useColorModeValue('var(--app-bg, #ffffff)', 'var(--app-bg, #130d10)');

  return (
    <Box bg={bg} h="100vh" w="100vw">
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar
          hovered={hovered}
          setHovered={setHovered}
          mini={mini}
          setMini={setMini}
          routes={allowedRoutes} // Pasar las rutas filtradas al Sidebar
          display="none"
          {...rest}
        />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={
            mini
              ? { base: '100%', xl: 'calc( 100% - 90px )' }
              : { base: '100%', xl: 'calc( 100% - 290px )' }
          }
          maxWidth={
            mini
              ? { base: '100%', xl: 'calc( 100% - 90px )' }
              : { base: '100%', xl: 'calc( 100% - 290px )' }
          }
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                hovered={hovered}
                setMini={setMini}
                mini={mini}
                onOpen={onOpen}
                logoText={'Horizon UI Dashboard PRO'}
                brandText={pageTitle} // Usar rutas filtradas
                secondary={getActiveNavbar(allowedRoutes)} // Usar rutas filtradas
                theme={props.theme}
                setTheme={props.setTheme}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: '20px', md: '30px' }}
              pe="20px"
              minH="100vh"
              pt="50px"
              maxW={mini ? "2500px" : "1700px"}
              w="100%"
              transition="max-width 0.3s ease-in-out"
            >
              <Routes>
                {getRoutes(allowedRoutes)} {/* Usar rutas filtradas */}
                {/* {user?.rol != 'U1' && 
                <Route
                path="/"
                  element={<Navigate to="/admin/index" replace />}
                />}

                
{user?.rol == 'U1' &&
                <Route
                  path="/"
                  element={<Navigate to="/admin/index" replace />}
                />
} */}
                {/* <Route
                  path="/"
                  element={<Navigate to="/admin/index" replace />}
                /> */}
                {/* RUtas para menu de Obras */}
                <Route path="/urbanizacion" element={<ObrasUrbanizacion />} />
                <Route
                  path="/fraccionamiento"
                  element={<ObrasFraccionamiento />}
                />
                <Route
                  path="/division-terrenos"
                  element={<ObrasDivisionTerrenos />}
                />
                <Route path="/anuncios" element={<ObrasAnuncio />} />
                <Route path="/panteones" element={<ObrasPanteon />} />
                {/* <Route path="/construccion-base" element={<ObrasConstruccionBase />} /> */}
                <Route path="/demoliciones" element={<ObrasDemolicion />} />
                <Route path="/constancias" element={<ObrasConstancia />} />
                <Route
                  path="/contratistas"
                  element={<ObrasRegistroContratista />}
                />
                <Route
                  path="/obstruccion-temporal"
                  element={<ObrasObstruccionTemporal />}
                />
                <Route
                  path="/multas-obstruccion"
                  element={<ObrasMultaObstruccion />}
                />
                <Route
                  path="/gestion-tramites-op"
                  element={<GestionTramitesOP />}
                />
                <Route
                  path="/obras-dashboard"
                  element={<DashboardObrasPublicas />}
                />
              </Routes>
            </Box>
          ) : null}
          <Box>
            <FooterPortalCiudadano />
          </Box>
        </Box>
      </SidebarContext.Provider>
      <Box></Box>
    </Box>
  );
}
